module.exports = __webpack_public_path__ + "static/dolphinclub-promo-541cb10c0b4dedb9e7ddbf63967382d4.png";